'use client'
import {
    useGetCartItemsQuery,
    useProductsCatalogMutation,
} from '@/shared/api-rtk'
import { useEffect, useState } from 'react'
import { links } from '../consts/links'


export function HomeCategories({ onMount }) {
    const [getData, { error }] = useProductsCatalogMutation()
    // const { items: itemsFavorite } = useSelector((state) => state.favorite)
    // const { isAuth } = useSelector((state) => state.authUser)
    const [data, setData] = useState([])

    const { data: productsInCart, isLoading, refetch } = useGetCartItemsQuery()
    useEffect(() => {
        if (data.length) return
        getData()
            .unwrap()
            .then((res) => {
                if (res.result === 'success') {
                    const result = Object.values(res.data).sort(
                        (a, b) =>
                            new Date(b.date_available) -
                            new Date(a.date_available)
                    )
                    setData(Object.values(result))
                    refetch()
                }
            })
            .finally(() => {
                setTimeout(() => onMount(), 500)
            })
    }, [data?.length, refetch])

    // console.log(data)

    return (
        <div className='HomeCategoriesContainer'>
            {/* <h1>Новинки</h1> */}
            <div className="items-container">
                {links?.map((item, index) => {
                    return (
                        <a href={item.href} key={index}>
                            <img src={item.image} alt={`${item.name}/${item.image}`} />
                            <span>{item.name}</span>
                        </a>
                    )
                })}
                {error && <span>Ошибка сервера, перезагрузите страницу</span>}
            </div>
        </div>
    )
}
